// extracted by mini-css-extract-plugin
export default {"text_container":"GameMode_text_container__Zoegr","back_btn":"GameMode_back_btn__RlS3m","back_icon":"GameMode_back_icon__Z+XwZ","text":"GameMode_text__S8SBy"};